var map = {
	"./0.webp": "cda9",
	"./1.webp": "4594",
	"./2.webp": "5025",
	"./bg.webp": "4cef",
	"./bg4.webp": "33aa",
	"./off.webp": "7ebe",
	"./on.webp": "993d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d11a";